import React, { useState } from 'react';
export function YouTubeChannels() {
  const [isOpen, setIsOpen] = useState(false);
  const channels = [{
    id: 1,
    name: 'NutellaGuyAU',
    link: 'https://www.youtube.com/@nutellaguyau/streams',
    description: 'Most popular giveaway channel – check out live streams and giveaways!',
    image: 'https://yt3.googleusercontent.com/tJ0zyqS6D_FLfW0dF9pUVcsT19gR_NCDykk-aCdR9tgVuQfP5Q7FrIYCAleMNXH0OlA2MxXTOA=s160-c-k-c0x00ffffff-no-rj',
    isGiveaway: true
  }, {
    id: 2,
    name: 'BLANIES',
    link: 'https://www.youtube.com/@BLAINES',
    description: 'Also has good giveaways! Remember, for his channel, just follow how he says to do the giveaways.',
    image: 'https://yt3.googleusercontent.com/ytc/AIdro_mYU5o-M28uZ2_LSncU-4X82pKzCR3tLiXChKPtyRX8qZ4=s160-c-k-c0x00ffffff-no-rj',
    isGiveaway: true
  }];
  return <section className="bg-slate-800/70 rounded-lg p-6 backdrop-blur-sm border border-slate-700 shadow-lg" data-id="element-394">
      <button className="w-full flex items-center justify-between bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors" onClick={() => setIsOpen(!isOpen)} data-id="element-395">
        <span className="text-xl" data-id="element-396">Pokémon YouTube Channels</span>
        <svg className={`w-6 h-6 transition-transform ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-397">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-398"></path>
        </svg>
      </button>
      {isOpen && <div className="space-y-4 mt-4 p-2 bg-slate-700/60 rounded-lg" data-id="element-399">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-400">
            {channels.map(channel => <div key={channel.id} className="bg-slate-700/60 rounded-lg p-4 border border-slate-600 shadow-md transition-transform hover:scale-[1.02]" data-id="element-401">
                <div className="flex flex-col sm:flex-row gap-4" data-id="element-402">
                  {channel.image && <div className="flex-shrink-0" data-id="element-403">
                      <img src={channel.image} alt={`${channel.name} channel`} className="w-20 h-20 rounded-full object-cover border-2 border-slate-500" data-id="element-404" />
                    </div>}
                  <div className="flex-1" data-id="element-405">
                    <div className="flex items-center gap-2 mb-1" data-id="element-406">
                      <h3 className="text-xl font-semibold text-yellow-300" data-id="element-407">
                        {channel.name}
                      </h3>
                      {channel.isGiveaway && <span className="bg-gradient-to-r from-pink-500 to-purple-500 text-white text-xs px-2 py-1 rounded-full" data-id="element-408">
                          🎁 Giveaway
                        </span>}
                    </div>
                    <p className="text-gray-200 mb-3" data-id="element-409">{channel.description}</p>
                    <a href={channel.link} target="_blank" rel="noopener noreferrer" className="inline-block bg-red-600 hover:bg-red-700 text-white text-sm font-medium px-3 py-1 rounded-md transition-colors" data-id="element-410">
                      Visit Channel
                    </a>
                  </div>
                </div>
              </div>)}
          </div>
          <div className="p-4 bg-slate-700/40 rounded-lg border border-slate-600" data-id="element-411">
            <p className="text-gray-300 text-sm" data-id="element-412">
              <span className="text-yellow-300 font-medium" data-id="element-413">Note:</span> These
              channels frequently host Pokémon giveaways and provide valuable
              content for trainers. More channels will be added soon! Btw, the
              only videos that work are the ones with the "LIVE" icon on the
              bottom left of the thumbnail.
            </p>
          </div>
        </div>}
    </section>;
}